module.exports = __webpack_public_path__ + "static/img/newlogo.d977ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/newlogo.png
// module id = kqgE
// module chunks = 1